module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-blurbs element-with-heading",
    attrs: {
      "id": "blurbs"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "blurbs-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Praise for Alex Walters")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "blurbs-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('b', [_vm._v("\"")]), _vm._v("I really enjoyed this new crime series and will definitely be looking to read the next book when it comes along.\" "), _c('b', [_vm._v("Joanne Robertson - My Chestnut Reading Tree")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"Alex Walters’ crime debut is a great read, it is exciting and intriguing and I simply loved this detective novel.\" "), _c('b', [_vm._v("Caroline Vincent - Bits About Books")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"Superb!\" "), _c('b', [_vm._v("Chris Nolan - Goodreads Reviewer")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"This is the first book in a new series for Alex Walters which I am positive will gather quite a following very quickly, myself being one of them.\" "), _c('b', [_vm._v("Susan Hampson - Books From Dusk Till Dawn")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"Dark, powerful and utterly absorbing with a satisfying ending I didn’t see coming. Loved it.\" "), _c('b', [_vm._v("Deborah - Goodreads Reviewer")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"A book of many threads that are skillfully drawn out and all solved by the novels end - a definite, must read.\" "), _c('b', [_vm._v("Sue Gale - Goodreads Reviewer")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"The pacing & smooth prose makes for effortless reading, one of those books where you’re surprised to see how far you’ve gone when you finally look up. \" "), _c('b', [_vm._v("Sandy - Goodreads Reviewer")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"A fantastic thriller that I would have no hesitation to recommend and will be keenly keeping an eye out for more books featuring Alec McKay!\" "), _c('b', [_vm._v("Kate Noble - The Quiet Knitter")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"This is a fast paced easy read full of twists and turns that I didn't see coming not to mention the OMG moments.\" "), _c('b', [_vm._v("Shell Baker - Chelle's Book Reviews")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"I thought that this was a brilliant book and as soon as I finished I knew it was going to have to be a 5 stars read and up there with my top crime reads of the year!\" "), _c('b', [_vm._v("Donna Maguire - Donnas Book Blog")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"A great detective thriller and I look forward to McKay’s next investigation!\" "), _c('b', [_vm._v("Clair Boor - Have Books Will Read")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("\"This book was a nail biting ,crisp dark read...that keeps you guessing all the way through....\" "), _c('b', [_vm._v("Livia Sbarbaro - Goodreads Reviewer")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container",
    staticStyle: {
      "width": "25.7%"
    }
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/dog-cut-out.jpg"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ac22f50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise-for-alex-walters.vue
// module id = 72
// module chunks = 0